import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Optimizechicago() {
  return (
    <section
      className="optimize_chicago p-100"
      style={{ background: "#FBFBFB" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>
              Optimize Business Operations with Mobile App Development in
              Chicago
            </h2>
            <p>
              For Chicago enterprises, mobile app development is a strategic
              asset. Our technical expertise in cross-platform development, API
              integration, and cybersecurity ensures the creation of powerful,
              secure, and scalable apps. A high-performing app enhance business
              operations, enable seamless customer interactions, and provide
              actionable insights – necessary to drive productivity,
              competitiveness, and profitability.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book A Consultation Now
            </Link>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <StaticImage
              src="../../images/location_new/chicago/optimize_chicago.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={672}
              height={680}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Optimizechicago;
